import { configure } from 'mobx';
import { RootStore } from './RootStore.js';

/** @typedef {import('../../services/myProductsApi').ProductsGroup} ProductsGroup */

configure({ enforceActions: 'observed' });

/**
 * @param {object} data
 * @param {import('./config/OptionsStore').CartSettings} data.initialSettings
 * @param {ProductsGroup[]} data.productGroups
 * @param {object} data.labelsObj
 * @param {object} data.localeObj
 * @param {HTMLElement} data.appMountPoint
 * @param {Boolean} data.isPublic
 * @param {object} data.selectorConfiguration
 * @returns {object}
 */
export const createStore = ({
  initialSettings,
  productGroups,
  labelsObj,
  localeObj,
  appMountPoint,
  isPublic,
  selectorConfiguration
}) => {
  const {
    labelsStore,
    cartStore,
    optionsStore,
    comparatorStore,
    uiStore,
    confirmStore,
    relatedRootStore,
    substRootStore,
    documentsStore,
  } = new RootStore({
    initialSettings,
    productGroups,
    labelsObj,
    localeObj,
    appMountPoint,
    isPublic,
    selectorConfiguration
  });

  return {
    labelsStore,
    cartStore,
    optionsStore,
    comparatorStore,
    uiStore,
    confirmStore,
    relatedRootStore,
    substRootStore,
    documentsStore,
    isPublic
  };
};
